import { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
// form
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
// @mui
import { LoadingButton } from '@mui/lab';
import { Alert, IconButton, InputAdornment, Link, Stack } from '@mui/material';
// routes
// hooks
// import useAuth from '../../../hooks/useAuth';
// import useIsMountedRef from '../../../hooks/useIsMountedRef';
// components
import { useDispatch } from 'react-redux';
// eslint-disable-next-line import/no-unresolved
import { useSnackbar } from 'notistack';
// eslint-disable-next-line import/no-unresolved
import { messaging } from 'src/firebase';
import AxiosAll from 'src/services/axiosAll';
import Iconify from '../../../components/Iconify';
import FormProvider from '../../../components/hook-form/FormProvider';
import { RHFCheckbox } from '../../../components/hook-form/RHFCheckbox';
import RHFTextField from '../../../components/hook-form/RHFTextField';
import { addLogin } from '../../../redux/actions/login';
// ----------------------------------------------------------------------

export default function LoginForm() {
  // const { login } = useAuth();
  const dispatch = useDispatch();
  // const isMountedRef = useIsMountedRef();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const LoginSchema = Yup.object().shape({
    email: Yup.string().email('Email must be a valid email address').required('Email is required'),
    password: Yup.string().required('Password is required'),
  });

  const defaultValues = {
    email: '',
    password: '',
    remember: true,
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    reset,
    setError,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    const payload = {
      email: data.email,
      password: data.password,
    };
    try {
      const response = await AxiosAll('post', '/login', payload);
      const data = response?.data;
      if (data?.statusCode === 200) {
        enqueueSnackbar(data?.message, { variant: 'success' });
        await dispatch(addLogin(data?.data));
        localStorage.setItem('user', JSON.stringify(data?.data.user));
        if (data?.data?.user?.role_id === 2) {
          await navigate('/kanban', { replace: true });
        } else {
          await navigate('/dashboard', { replace: true });
        }
      } else {
        enqueueSnackbar(response?.data?.message, { variant: 'error' });
      }
    } catch (error) {
      console.log(error);
      // reset();
    }
  };
  // for FCM token , helps in firebase message.
  const getFCMToken = async () => {
    const fcmToken = await messaging().getToken();
    if (fcmToken) {
      // console.log("token", fcmToken);
    } else {
      console.log('Failed', 'No token received');
    }
  };

  useEffect(() => {
    getFCMToken();
  }, []);

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>}

        <RHFTextField name="email" label="Email address" />

        <RHFTextField
          name="password"
          label="Password"
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
        <RHFCheckbox name="remember" label="Remember me" />
        <Link component={RouterLink} variant="subtitle2" to={'/reset-password'}>
          Forgot password?
        </Link>
      </Stack>

      <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
        Login
      </LoadingButton>
    </FormProvider>
  );
}
